<template>
    <main-content>
        <div class="bg-white shadow-sm rounded px-4 pb-4">
            <div v-if="step === 'otp'">
                <otp-form :form_data="otp_form_data"
                          :form_meta_data="otp_form_meta_data"
                          :on_submit="submitOtp"
                >
                </otp-form>
            </div>
            <div v-else-if="step === 'charge'">
                <charge-form :form_data="form_data"
                             :form_meta_data="form_meta_data"
                             :on_submit="chargeByBill"
                >
                </charge-form>
            </div>
        </div>
    </main-content>
</template>

<script>
    import ChargeForm from './components/charge-by-bill-form';
    import OtpForm from './components/charge-by-otp-form';
    import mainContent from '@/components/main-content';
    import {i18n} from '@/plugins/i18n';
    import $ from 'jquery';
    import {walletService} from '@/common/api.service';

    export default {
        components: {
            OtpForm,
            ChargeForm,
            mainContent,
        },
        data() {
            return {
                step: 'otp',
                invoice_id: '',
                otp_form_data: {
                    amount: '',
                    pan: '',
                },
                form_data: {
                    pin: '',
                    merchant_cid: '',
                },
                otp_form_meta_data: {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('btn.get_pin'),
                },
                form_meta_data: {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('wallets.label.charge'),
                },
            };
        },
        methods: {
            submitOtp() {
                let form = $('#otp_form');

                form.validate({
                    rules: {
                        amount: {
                            required: true,
                        },
                        pan: {
                            required: true,
                        },
                    }
                });

                if (!form.valid()) {
                    return;
                }

                this.otp_form_meta_data.submit_btn_progress = true;

                let params = {
                    amount: this.otp_form_data.amount,
                    pan: this.otp_form_data.pan,
                };

                walletService.getPin(params, this.$route.params.hashid).then(response => {
                    this.invoice_id = response.data.data.invoice_id;
                    this.step = 'charge';
                }).catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data);
                    }

                    this.showMsg(form, 'danger', response.data.message);
                }).finally(() => {
                        this.otp_form_meta_data.submit_btn_progress = false;
                    }
                );
            },
            chargeByBill() {
                let form = $('#submit_form');

                form.validate({
                    rules: {
                        pin: {
                            required: true,
                        },
                        merchant_cid: {
                            required: true,
                        },
                    }
                });

                if (!form.valid()) {
                    return;
                }

                this.form_meta_data.submit_btn_progress = true;

                let params = {
                    pin: this.form_data.pin,
                    merchant_cid: this.form_data.merchant_cid,
                    invoice_id: this.invoice_id,
                    pan: this.otp_form_data.pan,
                };

                walletService.chargeByBill(params, this.$route.params.hashid).then(response => {
                    this.$router.push('/wallets');
                }).catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data);
                    }

                    this.showMsg(form, 'danger', response.data.message);
                }).finally(() => {
                        this.form_meta_data.submit_btn_progress = false;
                    }
                );
            },
        },
    }
</script>
